import { StandardTable } from "@/components/table/StandardTable";
import { Flex, Text } from "@chakra-ui/react";
import { ReactNode, useMemo } from "react";

interface ProductItem {
  idProducto: number;
  nombreProducto: string;
  cantidad: string;
}

interface Props {
  items: ProductItem[];
  rightElement?: ReactNode;
}

export const PurchaseOrderIntentProductsTable = ({
  items,
  rightElement,
}: Props) => {
  const headers = useMemo(
    () => [
      { label: "Nombre", value: "nombreProducto", align: "inherit" },
      {
        label: "Cantidad",
        value: "cantidad",
        align: "inherit",
      },
      {
        label: "Unidad de medida",
        value: "unidadMedida",
        align: "inherit",
      },
    ],
    [],
  );

  return (
    <Flex flexDir="column" gap="8px">
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontWeight={700}>Productos solicitados</Text>
        {rightElement}
      </Flex>
      <StandardTable
        items={items}
        headers={headers}
        noSelection
        noActions
        rowId="idProducto"
        fullWidth
        maxHeight="240px"
      />
    </Flex>
  );
};
